// extracted by mini-css-extract-plugin
export default {"cart_total_div":"carttotal_cart_total_div__AMbRF","item":"carttotal_item__V-d8u"};